import React from 'react';
import { Link } from 'react-router-dom';
import GuidePageLayout from '../../components/seo/GuidePageLayout';

const FREE_TRIAL_URL = 'https://buy.stripe.com/5kA6rt11z6Dw06YbII';

export default function BetfairConnectionAndSecurity() {
  return (
    <GuidePageLayout currentPath="/betfair-connection-and-security">
      <h1>Betfair connection &amp; security</h1>
      <p>
        Connecting Betfair is a core step: Horse Racing Oracle needs permission to place bets you authorise, within the
        limits you set. This page explains what that connection is for, at a high level, and how to think about
        security. For product-specific steps, use the in-app <strong>Connect Betfair</strong> flow after you sign in.
      </p>

      <h2>Why a connection is required</h2>
      <p>
        Betfair does not let third parties place bets without explicit customer authorisation. The connection flow exists
        so <strong>only your account</strong> can act under your instructions, using Betfair&apos;s supported
        authentication mechanisms.
      </p>

      <h2>What you should expect</h2>
      <ul>
        <li>You will authenticate with Betfair and approve access for the Horse Racing Oracle application.</li>
        <li>You can review and revoke access through Betfair&apos;s own account/security settings.</li>
        <li>You should use a strong password and protect devices where you stay signed in.</li>
      </ul>

      <h2>Data minimisation (principle)</h2>
      <p>
        The product is designed to use the data needed to evaluate markets and manage your activity—not to request
        unrelated personal data. Full detail is in our <Link to="/privacy-policy">privacy policy</Link>.
      </p>

      <h2>If something looks wrong</h2>
      <p>
        If you see unexpected activity, change your Betfair credentials, review active sessions, and{' '}
        <Link to="/contact">contact us</Link>. For order or billing issues with third-party checkout, follow the
        instructions on your receipt and our <Link to="/refund-policy">refund policy</Link>.
      </p>

      <p>
        For how automation behaves after connection, read <Link to="/how-it-works">How it works</Link> and{' '}
        <Link to="/staking-and-risk-controls">Staking &amp; risk controls</Link>.
      </p>

      <div className="guideCta">
        <p className="guideCtaTitle">Start with a trial</p>
        <a
          className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-gradient-to-r from-primary-200 via-primary-100 to-primary-200 hover:from-primary-100 hover:to-primary-100 transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
          href={FREE_TRIAL_URL}
          rel="noopener noreferrer"
        >
          Free trial
          <svg className="ml-2 -mr-1 w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </a>
      </div>
    </GuidePageLayout>
  );
}
